import { render, staticRenderFns } from "./DeleteBrand.vue?vue&type=template&id=56d10b56&"
import script from "./DeleteBrand.vue?vue&type=script&lang=js&"
export * from "./DeleteBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports